export default __webpack_public_path__ + "static/media/european-cars.311f3b11.svg";